
export default class Room {

	static getHolderSelectors = () => ['.room-element'];

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {

		const galleryElement = holderElement.querySelector('.room-gallery-slider');
		const galleryArrows = holderElement.querySelector('.room-gallery-arrows');

		const floorPlansElement = holderElement.querySelector('.floor-plans-slider');
		const floorPlansArrows = holderElement.querySelector('.floor-plans-arrows');

		if (galleryElement) {
			new LuminousGallery(galleryElement.querySelectorAll('a'));
		}
		
		if (floorPlansElement) {
			new LuminousGallery(floorPlansElement.querySelectorAll('a'));
		}



		this.#createSlider(galleryElement, galleryArrows);
		this.#createSlider(floorPlansElement, floorPlansArrows);





		const features = holderElement.querySelector('.features');
		if (features) {
			const featuresObserver = new IntersectionObserver(entries => {
				if (!entries[0].isIntersecting) {
					return;
				}
				features.classList.add('scrolled');
				featuresObserver.disconnect();
			});
			featuresObserver.observe(features);
		}



		const headerPosition = document.querySelector('.header-position-holder');
		headerPosition.classList.add('d-none');

		const header = document.querySelector('header');
		header.classList.add('unpinned');
		let pinned = false;
		const navObserver = new IntersectionObserver(entry => {
			if (entry[0].isIntersecting && pinned) {
				holderElement.classList.remove('pinned');
				pinned = false;
			} else if (!entry[0].isIntersecting && !pinned) {
				holderElement.classList.add('pinned');
				pinned = true;
			}
		});
		navObserver.observe(header);

	}


	/**
	 * @param {HTMLElement} sliderElement
	 * @param {HTMLElement} arrowsElement
	 */
	#createSlider(sliderElement, arrowsElement) {
		if (!sliderElement) {
			return;
		}
		const slider = new Splide(sliderElement, {
			type: 'loop',
			perPage: 1,
			perMove: 1,
			pagination: false,
			arrows: false,
		});
		slider.mount();

		if (!arrowsElement) {
			return;
		}
		const sliderControls = arrowsElement.querySelectorAll('[data-slider-control]');
		sliderControls.forEach(sliderControl => {
			sliderControl.addEventListener('click', () => {
				slider.go(sliderControl.dataset.sliderControl);
			});
		});
	}

}
